var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.726562H513V342.693H0V0.726562Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 0.726562V23.3707L210.31 54.1307H256.5V118.256H210.31L256.5 149.016V171.76H233.856L160.312 122.664V171.76H96.1875V122.664L22.6441 171.76H0V149.016L46.19 118.256H0V54.1307H46.19L0 23.3707V0.726562H22.6441L96.1875 49.7221V0.726562H160.312V49.7221L233.856 0.726562H256.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.281 0.726562H112.219V70.1619H0V102.224H112.219V171.76H144.281V102.224H256.5V70.1619H144.281V0.726562Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.726562V15.8561L57.5121 54.1307H80.1562L0 0.726562ZM256.5 0.726562V15.8561L198.988 54.1307H176.344L256.5 0.726562Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.726562V15.8561L57.5121 54.1307H80.1562L0 0.726562ZM256.5 0.726562V15.8561L198.988 54.1307H176.344L256.5 0.726562ZM0 171.76V156.63L57.5121 118.256H80.1562L0 171.76ZM256.5 171.76V156.63L198.988 118.256H176.344L256.5 171.76Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.7 128.075V220.254C307.7 281.975 388.357 300.912 388.357 300.912C388.357 300.912 468.914 281.875 468.914 220.154V127.975L388.257 104.93L307.7 128.075Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.914 133.786V99.2188H307.7V133.786H376.835V202.921H307.7V225.966H376.835V297.305C383.748 299.81 388.357 300.812 388.357 300.812C388.357 300.812 392.966 299.71 399.88 297.305V225.966H469.014V202.921H399.88V133.786H468.914Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.726562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj);
export default __webpack_public_path__ + "static/media/FJ.bc2d0ff3489ae81a697be28e43235e72.svg";
export { ForwardRef as ReactComponent };